import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/pages/DashboardLayout";
import Overview from "@/pages/Overview";
import Vision from "@/pages/Vision";
import Scorecard from "@/pages/Scorecard";
import Rocks from "@/pages/Rocks";
import Issues from "@/pages/Issues";
import Meetings from "@/pages/Meetings";
import Accountability from "@/pages/Accountability";
import Processes from "@/pages/Processes";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
            <Route index element={<Overview />} />
            <Route path="vision" element={<Vision />} />
            <Route path="scorecard" element={<Scorecard />} />
            <Route path="rocks" element={<Rocks />} />
            <Route path="issues" element={<Issues />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="accountability" element={<Accountability />} />
            <Route path="processes" element={<Processes />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
